<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'
import { notificationError } from '@/app/core/util/notificationUtils'
import { useI18n } from 'vue-i18n'
import Popper from 'vue3-popper'
import { DBtn, DTextField, DLoading, Edit03Icon,DTable } from 'front-library'
import { getProcesses, Process } from '@/app/core/services/processes'
import { useUserStore } from '@/store/user'

/* store, router, notifications */
const router = useRouter()
const store = useUserStore()
const notifications = useNotificationsStore()
const { t } = useI18n()

const loading = ref(false)

/* Datos */
const search = ref()

/* Datos componente table */
const columns = ref([
  {
    name: 'code',
    title: t('processes.list.code'),
    table: 'code'
  },
  {
    name: 'name',
    title: t('processes.list.name'),
    table: 'name'
  },
  {
    name: 'countries',
    title: t('processes.list.countries'),
  
  },
  
  {
    name: 'showInCalc',
    title: t('processes.list.showInCalc'),
    table: 'showInCalc'
  },

  {
    name: 'automatic',
    title: t('processes.list.automatic'),
  },

  {
    name: 'updated_at',
    title: t('processes.list.lastUpdate'),
    table: 'updated_at'
  },

  { name: 'actions', title: '' }
])
const rows = ref<Process[]>([])
const perPage = ref(0)
const offset = ref(0)
const totalRows = ref(0)
const sortBy = ref('')

const getProcessesRows = async () => {
  loading.value = true
  try {
    const data = await getProcesses(
      offset.value,
      perPage.value,
      sortBy.value,
      search.value
    )
    rows.value = data.results
    totalRows.value = data.totalItems
    loading.value = false
  } catch (error: any) {
    notificationError(error, 'pendingProcesses', t, notifications, loading)
  }
}

const goToEdit = (id: any) => {
   router.push({ name: 'EditProcesses', params: { id } })
}

const goToCreate = () => {
  router.push({ name: 'CreateProcesses' })
}
</script>
<template>
  <DLoading v-show="loading" :message="t('loading.data')" />

  <div class="px-5 overflow-auto scroll">   
     
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p class="text-3xl font-semibold text-shadow">
          {{ t('processes.list.title') }}
        </p>
        <p class="text-gray-500 text-shadow">
          {{ t('processes.list.subtitle') }}
        </p>
      </div>
      <div class="sm:flex justify-between pt-8">
        <div class="flex mb-3 sm:mb-0 max-w-2xl sm:w-2/3 md:w-1/2 lg:w-5/12">
          <DTextField
            :placeholder="t('form.button.search') + '...'"
            :icon="'SearchLgIcon'"
            class="mr-2 w-full"
            v-model="search"
            @keyup.enter="getProcessesRows" />
          <DBtn
            @click.prevent="getProcessesRows"
            v-html="t('form.button.search')" />
        </div>
     
      </div>
    </div>
    <DTable
      :columns="columns"
      :rows="rows"
      :total-rows="totalRows"
      :select-options="false"
      :text-no-data="t('table.noData')"
      :text-per-page="t('table.rowsPerPage')"
      @perPage=";(perPage = $event), getProcessesRows()"
      @offset="offset = $event"
      @sort=";(sortBy = $event), getProcessesRows()">
      <template #countries="data :any">
        <div class="p-2 text-gray-500 text-sm ">
         <ul>
          <li v-for="(countryName,index) in data.countries" :key="index"  class="list-disc">{{ countryName }}</li>
         </ul>
        </div>
      </template>
      <template #automatic="data :any">
        <p class="p-2 text-gray-500 text-sm ">
          <span
          v-if="!data.automatic"
          >Manual</span>
         <ul v-else>
          <li v-for="(event ,index) in data.automatic" :key="index" class="list-disc">{{event }}</li>
         </ul>
        </p>
      </template>
       <template #actions="data :any">
      
         <Popper
            arrow
            offsetDistance="12"
            :content="t('table.action.edit')"
            :hover="true"
            placement="top"
            class="tooltip">
            <div
               v-if="store.hasPermission('process:update')"
              class="bg-gray-50 rounded-md py-2"
              @click="goToEdit(data.id)">
              <Edit03Icon class="h-6 w-6 mx-2 cursor-pointer text-gray-600" />
            </div>
          </Popper>
      </template>
    </DTable>
  </div>
</template>
